<template>
  <div class="form-content">
    <div class="header-box" v-if="isSingle != 1">
      <i class="header-icon"></i>
      <!-- <img class="header-img" :src="require('@/assets/imgs/person.png')" /> -->
      <label class="header-name">保险日期选择</label>
    </div>
    <van-form>
      <van-field
        v-if="isSingle != 1"
        readonly
        clickable
        required
        name="保险方案"
        label="保险方案"
        :value="categoryName"
        placeholder="选择保险方案"
        @click="showCategoryPicker = true"
      />
      <van-field
        v-if="showInputDate"
        required
        readonly
        clickable
        name="calendar"
        :value="stateDateValue"
        label="开始日期"
        placeholder="点击选择日期"
        @click="showStartCalendar = true"
      />
      <van-field
        v-if="lblMoney != ''"
        readonly
        clickable
        label="保费"
        :value="lblMoney"
        class="lblBf"
      />
    </van-form>
    <!-- <div class="header-box">
      <i class="header-icon"></i>
      <label class="header-name">投保人信息</label>
    </div>
    <van-form>
      <van-field
        v-model="dataForm1.taxPayerNumber"
        label="纳税人识别号"
        placeholder="请输入纳税人识别号"
      />
      <van-field name="radio" label="是否团单" required>
        <template #input>
          <van-radio-group
            v-model="dataForm1.groupOrder"
            direction="horizontal"
          >
            <van-radio :name="1">是</van-radio>
            <van-radio :name="0">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field name="radio" label="投保类型" required>
        <template #input>
          <van-radio-group
            v-model="dataForm1.companyFlag"
            direction="horizontal"
          >
            <van-radio :name="0">个人</van-radio>
            <van-radio :name="1">是否企业</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        required
        v-if="dataForm1.companyFlag == 1"
        v-model="dataForm1.companyName"
        label="企业名称"
        placeholder="请输入企业名称"
      />
      <van-field
        required
        v-if="dataForm1.companyFlag == 1"
        v-model="dataForm1.bankNo"
        label="银行账号"
        placeholder="请输入银行账号"
      />
      <van-field
        required
        v-if="dataForm1.companyFlag == 1"
        v-model="dataForm1.companyNo"
        label="社会信用代码"
        placeholder="请输入社会信用代码"
      />
      <van-field
        required
        v-if="dataForm1.companyFlag == 0"
        v-model="dataForm1.holderName"
        label="投保人姓名"
        placeholder="请输入投保人姓名"
      />
      <van-field
        required
        v-if="dataForm1.companyFlag == 0"
        v-model.number="dataForm1.holderAge"
        label="投保人年龄"
        placeholder="请输入投保人年龄"
      />
      <van-field
        required
        v-if="dataForm1.companyFlag == 0"
        name="radio"
        label="投保人性别"
      >
        <template v-if="dataForm1.companyFlag == 0" #input>
          <van-radio-group v-model="dataForm1.holderSex" direction="horizontal">
            <van-radio name="1">男</van-radio>
            <van-radio name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        required
        v-if="dataForm1.companyFlag == 0"
        v-model="dataForm1.holderMobile"
        label="投保人手机号"
        placeholder="请输入投保人手机号"
      />
      <van-field
        required
        v-if="dataForm1.companyFlag == 0"
        v-model="dataForm1.holderEmail"
        label="投保人邮箱"
        placeholder="请输入投保人邮箱"
      />
      <van-field
        required
        v-if="dataForm1.companyFlag == 0"
        v-model="dataForm1.holderIdNo"
        label="身份证号"
        placeholder="请输入投保人身份证号"
      />
    </van-form> -->
    <div class="header-box">
      <i class="header-icon"></i>
      <!-- <img class="header-img" :src="require('@/assets/imgs/person.png')" /> -->
      <label class="header-name">保障范围</label>
    </div>
    <div class="productinfo-view" v-show="showInfo">
      <div class="title">
        <div class="title-left">保险责任</div>
        <div class="title-right">保险金额(人民币)</div>
      </div>
      <div
        class="productinfo-item"
        v-for="(item, index) in infoOptions"
        :key="index"
      >
        <div class="content-box">
          <div class="left">{{ item.name }}</div>
          <div class="right">
            <div
              class="right-item"
              v-for="(name, idx) in item.contentList"
              :key="idx"
              v-html="handleShowName(name)"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="header-box">
      <i class="header-icon"></i>
      <!-- <img class="header-img" :src="require('@/assets/imgs/person.png')" /> -->
      <label class="header-name"
        >被保人信息(<span style="color: red; font-size: 0.8rem"
          >左侧滑动删除</span
        >)</label
      >
      <van-button
        v-if="isSingle != 1"
        style="position: absolute; right: 0.8rem"
        type="primary"
        size="mini"
        @click="handleAddClick"
        >添加</van-button
      >
    </div>
    <tbformitem
      v-for="(item, index) in usePeopleList"
      :key="index"
      :people="item"
      :num="usePeopleList.length"
      :ref="'child_' + index"
      :itemIndex="index"
      @delChild="handleDelClick"
      :fieldJson="useFieldJson"
      :rules="useRequired"
      :dictionaryList="dictionaryData"
      @setInsure="handleInsureChange"
      @historys="handleHistory"
      :single="isSingle"
      @showCategory="handleShowCateGory"
    ></tbformitem>
    <div class="aggrement-box" v-if="agreementList.length > 0">
      <label class="aggrement-default"
        >本人已充分了解本保险产品，同意并接受
      </label>
      &nbsp; &nbsp;
      <label
        class="aggrement-list"
        v-for="item in agreementList"
        :key="item.id"
        @click="handleAggrementClick(item.id)"
        >{{ " 《" + item.name + "》 " }}</label
      >
    </div>
    <van-calendar v-model="showStartCalendar" @confirm="onConfirm($event, 1)" />
    <van-calendar v-model="showEndCalendar" @confirm="onConfirm($event, 2)" />
    <div style="height: 5rem"></div>
    <div class="button-save">
      <van-button
        @click="handleGoClick"
        type="primary"
        :loading="loading"
        block
        :color="'#FFC281'"
        loading-text="投保中..."
        >投保</van-button
      >
    </div>
    <van-popup v-model="showCategoryPicker" position="bottom">
      <!-- <div class="search-box">
        <input
          class="search-input"
          :style="{ opacity: iOpacity, width: iWidth }"
        />
        <van-icon
          name="search"
          size="1.2rem"
          class="showsearch"
          @click="handleShowSearch"
          v-if="iOpacity == 0"
        />
        <van-icon
          name="close"
          size="1.2rem"
          class="hidesearch"
          @click="handleHideSearch"
          v-if="iOpacity == 1"
        />
      </div> -->
      <van-picker
        show-toolbar
        value-key="name"
        :columns="categoryLists"
        @confirm="handleCategoryPickerOk"
        @cancel="showCategoryPicker = false"
      />
    </van-popup>
    <div class="flot-box" @click="handleHistoryListClick" v-if="isShowHistory">
      <van-icon name="orders-o" color="white" size="40px" />
    </div>
    <van-popup v-model="showHistory" position="bottom" style="height: 50%">
      <div class="history-view">
        <div
          class="history-item"
          v-for="(item, index) in historyList"
          :key="index"
        >
          <div class="left">
            <div class="top">{{ item.insureName }}</div>
            <div class="bottom">{{ item.insureIdNo }}</div>
          </div>
          <div class="right">
            <van-button type="info" size="mini" @click="handleHFClick(item)"
              >恢复</van-button
            >
            <van-button
              type="primary"
              size="mini"
              @click="handleHisDelClick(index)"
              color="red"
              >删除</van-button
            >
          </div>
        </div>
        <van-empty v-if="historyList.length == 0" description="暂无历史" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  findProductById,
  getJsapiTicket,
  createDriverInsure,
  getCategoryByProductId,
  findDictionaryByCode,
} from "@/api/common";
import tbformitem from "./tb_form_item";
import { Toast, Notify, Dialog } from "vant";
import { isMobile, isCard } from "@/utils/validate";
export default {
  components: { tbformitem },
  data() {
    return {
      showInputDate: false,
      showEndCalendar: false,
      showStartCalendar: false,
      stateDateValue: "",
      endDateValue: "",
      usePeopleList: [],
      loading: false,
      agreementList: [],
      lblMoney: "",
      dataForm: {
        insurStartDate: "",
        insurEndDate: "",
        productId: "",
        belongerId: "",
        categoryId: "",
        peopleList: [],
      },
      dataForm1: {
        companyFlag: 0,
        groupOrder: 0,
        bankNo: "",
        companyName: "",
        holderEmail: "",
        holderMobile: "",
        holderBirthday: "",
        holderAge: "",
        holderSex: "1",
        holderName: "",
        holderIdNo: "",
        taxPayerNumber: "",
        companyNo: "",
      },
      usePeopleList: [],
      useFieldJson: [],
      useRequired: {},
      productData: {},
      categoryName: "",
      showCategoryPicker: false,
      categoryLists: [],
      dictionaryData: [],
      showInfo: true,
      infoOptions: [],
      iOpacity: 0,
      iWidth: 0,
      historyData: {
        insurStartDate: "",
        insurEndDate: "",
        productId: "",
        categoryId: "",
        peopleList: [],
      },
      historyList: [],
      loadHistoryData: {},
      showHistory: false,
      isFirst: true,
      isSingle: 1,
    };
  },
  async activated() {
    document.title = "阳光保险";
    this.dataForm.belongerId = this.$route.query.belongerId || "";
    this.dataForm.productId = this.$route.query.productId || "";

    let sHistory = localStorage.getItem("historys") || "";
    if (!this.$ComTools.isEmptyString(sHistory)) {
      this.historyData = JSON.parse(sHistory);
    }
    this.dictionaryData = await this._findDictionaryByCode();
    if (!this.$ComTools.isEmptyString(this.dataForm.productId)) {
      this._findProductById();
      this._getCategoryByProductId();
    }
  },
  mounted() {
    let sUrl = location.href.split("#")[0];
    let sImgUrl = "http://nywx.e-ibdt.cn/file/logo/logo_sinosig.png";
    getJsapiTicket({ appid: process.env.WXKey, url: sUrl }).then((res) => {
      if (res.code === 0) {
        this.$ComTools.wxShare(res.data, sUrl, sImgUrl, "阳光保险");
      }
    });
  },
  watch: {
    dataForm: {
      handler(val, old) {
        if (val.categoryId != old.categoryId) {
          this.historyData.categoryId = val.categoryId;
        }
        if (val.insurStartDate != old.insurStartDate) {
          this.historyData.insurStartDate = val.insurStartDate;
        }
        if (val.insurEndDate != old.insurEndDate) {
          this.historyData.insurEndDate = val.insurEndDate;
        }
        if (
          val.categoryId != old.categoryId ||
          val.insurStartDate != old.insurStartDate ||
          val.insurEndDate != old.insurEndDate
        ) {
          localStorage.setItem("historys", JSON.stringify(this.historyData));
        }
      },
      deep: true,
    },
  },
  methods: {
    handleHistory(row, index) {
      this.historyData.productId = this.dataForm.productId;
      this.historyData.categoryId = this.dataForm.categoryId;
      this.historyData.insurStartDate = this.dataForm.insurStartDate;
      this.historyData.insurEndDate = this.dataForm.insurEndDate;
      this.historyData.peopleList[index] = row;

      localStorage.setItem("historys", JSON.stringify(this.historyData));
    },
    handleShowSearch() {
      this.iOpacity = 1;
      //  setTimeout(() => {
      this.iWidth = "10rem";
      //  });
    },
    handleHideSearch() {
      this.iOpacity = 0;
      //  setTimeout(() => {
      this.iWidth = 0;
      //  });
    },
    _findDictionaryByCode() {
      return new Promise((resolve, reject) => {
        findDictionaryByCode().then((res) => {
          resolve(res.data || []);
        });
      });
    },
    _findProductById() {
      findProductById({ id: this.dataForm.productId }).then((res) => {
        if (res.code == 0 && !this.$ComTools.isEmptyString(res.data)) {
          this.productData = res.data;
          this.isSingle = res.data.single;
          this.agreementList = res.data.agreementList || [];
          if (this.usePeopleList.length == 0) {
            this.handleAddClick();
          }
        }
      });
    },
    _getCategoryByProductId() {
      getCategoryByProductId({ productId: this.dataForm.productId }).then(
        (res) => {
          this.categoryLists = res.data;
        }
      );
    },
    handleAddClick() {
      let sFiledJson = this.productData.fieldJson;
      if (!this.$ComTools.isEmptyString(sFiledJson)) {
        let aFileJson = JSON.parse(sFiledJson);
        this.useFieldJson = this.$ComTools.assertOfDepth(aFileJson);
        let oUsePeople = {};
        if (this.usePeopleList.length == 0) {
          oUsePeople.holderFlag = true;
        } else {
          oUsePeople.holderFlag = false;
        }

        for (let i = 0; i < aFileJson.length; i++) {
          let oFileJson = aFileJson[i];
          oUsePeople[oFileJson.key] = "";
          if (oFileJson.required == "1") {
            this.useRequired[oFileJson.key] = {
              required: true,
              message: oFileJson.placeholder,
              trigger: "blur",
            };
          }
        }
        this.usePeopleList.push(oUsePeople);
      }
    },
    handleDelClick(index) {
      this.usePeopleList.splice(index, 1);
    },
    onConfirm(date, index) {
      if (index == 1) {
        this.dataForm.insurStartDate = date;
        this.stateDateValue = this.$DateTools.formatDatetime(
          "yyyy-MM-dd",
          date
        );
        this.showStartCalendar = false;
      } else {
        this.dataForm.insurEndDate = date;
        this.endDateValue = this.$DateTools.formatDatetime("yyyy-MM-dd", date);
        this.showEndCalendar = false;
      }
    },
    handleInsureChange(flag, index) {
      if (flag) {
        for (let i = 0; i < this.usePeopleList.length; i++) {
          if (i != index) {
            this.$refs["child_" + i][0].setSwitchInsure(false);
          }
        }
      }
    },
    handleCategoryPickerOk(a, b) {
      this.categoryName = a.name;
      this.showCategoryPicker = false;
      this.dataForm.categoryId = a.id;
      this.lblMoney = a.premium + "元";
      let sClauseJson = "";
      for (let i = 0; i < this.categoryLists.length; i++) {
        let obj = this.categoryLists[i];
        if (obj.id == a.id) {
          this.showInputDate = obj.timeFlag == 1 ? true : false;
          sClauseJson = obj.clauseJson;
          break;
        }
      }
      if (!this.$ComTools.isEmptyString(sClauseJson)) {
        let aClauseJson = JSON.parse(sClauseJson);
        let aTmp = [];
        for (let i = 0; i < aClauseJson.length; i++) {
          let item = aClauseJson[i];
          let sContent = item.content;
          item.contentList = [];
          if (!this.$ComTools.isEmptyString(sContent)) {
            item.contentList = sContent.split(",");
          }
          aTmp.push(item);
        }
        this.infoOptions = aTmp;
      }
    },
    handleAggrementClick(id) {
      this.$router.push({
        name: "aggrement",
        query: { id: id },
      });
    },
    isShowHistory() {
      let sHistory = localStorage.getItem("historys") || "";
      let bFlag = false;
      if (!this.$ComTools.isEmptyString(sHistory)) {
        let oHistory = JSON.parse(sHistory);
        if (oHistory.productId == this.dataForm.productId) {
          bFlag = true;
        }
      }
      return bFlag;
    },
    handleHistoryListClick() {
      //   let sHistory = localStorage.getItem("historys") || "";
      //  this.historyList = [];
      //  if (!this.$ComTools.isEmptyString(sHistory)) {
      //   let oHistory = JSON.parse(sHistory);
      //    if (oHistory.categoryId == this.dataForm.categoryId) {
      this.historyList = this.historyData.peopleList;
      //   }
      //  }
      this.showHistory = true;
    },
    handleHFClick(item) {
      if (this.isFirst) {
        this.usePeopleList = [];
      }
      this.isFirst = false;
      this.usePeopleList.push(item);
    },
    handleHisDelClick(index) {
      let sHistory = localStorage.getItem("historys") || "";
      let oHistory = {};
      if (!this.$ComTools.isEmptyString(sHistory)) {
        oHistory = JSON.parse(sHistory);
        oHistory.peopleList.splice(index, 1);
        this.historyList.splice(index, 1);
      }
      localStorage.setItem("historys", JSON.stringify(oHistory));
    },
    handleShowName(name) {
      return name.replace(
        /(\n|\r|(\r\n)|(\u0085)|(\u2028)|(\u2029))/g,
        "<br/>"
      );
    },
    handleShowCateGory(card) {
      if (this.dataForm.productId == "346670588510601216") {
        let date = new Date();
        let yearfull = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let birthyear = card.substring(6, 10);
        let age = yearfull - birthyear;
        if (
          month < card.substring(10, 12) ||
          (card.substring(10, 12) == month && day < card.substring(12, 14))
        ) {
          age--;
        }
        for (let i = 0; i < this.categoryLists.length; i++) {
          let row = this.categoryLists[i];
          if (age > 50) {
            if (row.id == "346671205199118336") {
              this.handleCategoryPickerOk(row);
              break;
            }
          } else {
            if (row.id == "346671163910389760") {
              this.handleCategoryPickerOk(row);
              break;
            }
          }
        }
      }
    },
    async handleGoClick() {
      this.dataForm.peopleList = [];
      if (this.$ComTools.isEmptyString(this.dataForm.categoryId)) {
        return Toast("请选择保险方案");
      }
      this.dataForm.peopleList = [];
      if (this.$ComTools.isEmptyString(this.dataForm.categoryId)) {
        return Toast("请选择保险方案");
      }
      if (
        this.showInputDate &&
        this.$ComTools.isEmptyString(this.dataForm.insurStartDate)
      ) {
        return Toast("请选择保险开始日期");
      }
      // if (this.$ComTools.isEmptyString(this.dataForm1.taxPayerNumber)) {
      //   return Toast("请输入纳税人识别号");
      // }
      // if (this.dataForm1.companyFlag == 1) {
      //   if (this.$ComTools.isEmptyString(this.dataForm1.companyName)) {
      //     return Toast("请输入企业名称");
      //   }
      //   if (this.$ComTools.isEmptyString(this.dataForm1.bankNo)) {
      //     return Toast("请输入银行账号");
      //   }
      //   if (this.$ComTools.isEmptyString(this.dataForm1.companyNo)) {
      //     return Toast("请输入社会信用代码");
      //   }
      // } else {
      //   if (this.$ComTools.isEmptyString(this.dataForm1.holderName)) {
      //     return Toast("请输入投保人姓名");
      //   }
      //   if (this.$ComTools.isEmptyString(this.dataForm1.holderAge)) {
      //     return Toast("请输入投保人年龄");
      //   }
      //   if (this.$ComTools.isEmptyString(this.dataForm1.holderSex)) {
      //     return Toast("请选择投保人性别");
      //   }
      //   if (this.$ComTools.isEmptyString(this.dataForm1.holderMobile)) {
      //     return Toast("请输入投保人手机号");
      //   }
      //   if (!isMobile(this.dataForm1.holderMobile)) {
      //     return Notify("手机号格式错误");
      //   }
      //   if (this.$ComTools.isEmptyString(this.dataForm1.holderEmail)) {
      //     return Toast("请输入投保人邮箱");
      //   }

      //   if (this.$ComTools.isEmptyString(this.dataForm1.holderIdNo)) {
      //     return Toast("请输入投保人身份证号");
      //   }
      //   if (!isCard(this.dataForm1.holderIdNo)) {
      //     return Notify("银行账号格式错误");
      //   }
      // }
      let bSave = true;
      let bHaseInsure = false;
      for (let i = 0; i < this.usePeopleList.length; i++) {
        let { flag, data, msg, binsure } = await this.$refs[
          "child_" + i
        ][0].handleValidate();
        //只要有一个未填就返回并清空所有数据
        if (binsure) {
          bHaseInsure = true;
        }
        if (!flag) {
          bSave = false;
          Toast(msg);
          break;
        } else {
          this.dataForm.peopleList.push(data);
        }
      }
      if (!bHaseInsure) {
        Toast("请设置一个投保人");
        return;
      }
      if (bSave && bHaseInsure) {
        this.loading = true;
        createDriverInsure(this.dataForm).then((res) => {
          this.loading = false;
          if (res.code === 0) {
            Dialog.confirm({
              title: "提示信息",
              message: "投保成功，是否前往支付",
            })
              .then(() => {
                window.location.href = res.data;
              })
              .catch(() => {
                // on cancel
              });
          } else {
            Notify(res.msg);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-content {
  width: 100%;
  min-height: 100%;
  .header-box {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0.8rem;
    position: relative;
    .header-icon {
      background-color: #ffc281;
      height: 1.4rem;
      width: 5px;
      display: block;
      margin-right: 0.5rem;
    }
    .header-img {
      width: 1.3rem;
      margin: 0 0.5rem;
    }
    .header-name {
      font-size: 1rem;
      font-weight: 600;
    }
  }
  & /deep/ .van-swipe-cell {
    .van-swipe-cell__wrapper {
      border-bottom: 1px dashed gray;
      &:last-child {
        border-bottom: none;
      }
    }
  }
  .button-save {
    /deep/ .van-button {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      // color: black !important;
    }
  }
  .flot-box {
    width: 50px;
    height: 50px;
    background-color: #ffc281;
    position: fixed;
    top: 82px;
    right: 25px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 5px 0 rgba(255, 194, 129, 1);
  }
  .history-view {
    width: 100%;
    height: 100%;
    padding: 10px 0px;
    .history-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 20px;
      border-bottom: 1px solid #f2f2f2;
      .left {
        width: 60%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
      }
      .right {
        height: 100%;
        width: 40%;
        text-align: right;
      }
    }
  }
}
.productinfo-view {
  padding: 10px 16px;
  .title {
    width: 100%;
    display: flex;
    padding: 8px 0;
    background-color: #f2f2f2;
    font-size: 0.8rem;
    color: #4caaf7;
    border: 1px solid #e3e1e2;
    font-weight: 600;
    border-bottom: none;
    .title-left {
      width: 30%;
      text-align: center;
    }
    .title-right {
      width: 70%;
      text-align: center;
    }
  }
  .productinfo-item {
    border: 1px solid #e3e1e2;
    border-bottom: none;
    &:first-child {
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
    &:last-child {
      border-bottom: 1px solid #e3e1e2;
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;
    }

    .content-box {
      width: 100%;
      // display: flex;
      // align-items: center;
      display: flex;
      .left {
        width: 30%;
        text-align: center;
        font-size: 0.8rem;
        color: #5e5e5e;
        padding: 5px 10px;
        display: flex;
        align-items: center;
      }
      .right {
        width: 70%;
        display: flex;
        flex-direction: column;
        border-left: 1px solid #e3e1e2;
        justify-content: center;
        .right-item {
          text-align: left;
          padding: 10px;
          border-bottom: 1px solid #e3e1e2;
          font-size: 0.8rem;
          color: #5e5e5e;
          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}
.aggrement-box {
  width: 100%;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .aggrement-default {
    font-size: 0.8rem;
    color: #646566;
  }
  .aggrement-list {
    font-size: 0.9rem;
    color: #ca9b51;
  }
}
.search-box {
  height: 44px;
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 60px;
  right: 60px;
  z-index: 1000;
  input {
    border-radius: 12px;
    border: 1px solid gray;
    padding: 0 5px;
    width: 0;
    opacity: 0;
    transition: width 0.3s;
    height: 65%;
  }
  .hidesearch {
    padding-left: 5px;
  }
}
.lblBf {
  & /deep/ .van-field__control {
    color: red;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/insurance/tb_form.vue